@if (logo$ | async; as logo) {
  <cx-media class="cx-logo" [media]="logo" />
}
